import React, { useContext } from 'react';
import type { ClassReportType, DateRangeOptionsType, HighlightedProps, PdfFilterType } from '../../types';
import type { TopicChartType } from '../../../mapper/groupTopicReportMapper';
import type { ManageMetricsType } from '../../../forms/types';
import type { DateRange } from '../../../util/types';
import { ChartsView, TablesView } from '../views';
import { PdfContext } from '../../../context/PdfContext';
import { DateTime } from 'luxon';
import classNames from 'classnames';

type Props = {
  classReport: ClassReportType;
  viewValue:  React.ReactElement<any, string | ((props: any) => (React.ReactElement<any, any> | null)) | { new(props: any): React.Component<any, any, any> }> | 'charts' | 'table' | null;
  labelValue: string;
  timeRangeValue:  { value: DateRangeOptionsType, label: string, endDate: DateTime | null } | null;
  filteredStudentsIds: number[];
  showOthersData: boolean;
  chartTopicProgress: TopicChartType[];
  pdfFilter?: PdfFilterType;
  metricsSettings?: ManageMetricsType;
  dateRange: DateRange;
  groupId: number;
} & Pick<HighlightedProps, 'onElementClick'>;

const ReportBody = (
  {
    classReport,
    viewValue,
    labelValue,
    timeRangeValue,
    filteredStudentsIds,
    showOthersData,
    chartTopicProgress,
    pdfFilter,
    metricsSettings,
    dateRange,
    groupId,
    onElementClick,
  }: Props,
): JSX.Element => {
  const { isPdf } = useContext(PdfContext);
  const endDateIsToday = !!(timeRangeValue?.endDate && (Math.floor(timeRangeValue.endDate?.diff(DateTime.now(), 'days').days) === 0));
  const showStudentStatus = 'custom' !== timeRangeValue?.value || ('custom' === timeRangeValue?.value && endDateIsToday);

  return (
    <div className={`space-y-4 md:space-y-6 ${classNames({ 'mb-40': ('charts' === viewValue) })}`} data-print-container>
      {'charts' === viewValue && (
        <ChartsView
          classReport={classReport}
          chartTopicProgress={chartTopicProgress}
          showOthersData={showOthersData}
          showStudentStatus={showStudentStatus}
          filterLabel={null !== labelValue ? labelValue as string : null}
          filteredIds={filteredStudentsIds}
          pdfFilter={pdfFilter}
          dateRange={dateRange}
          onElementClick={onElementClick}
        />
      )}
      {'table' === viewValue && !isPdf && (
        <TablesView
          classReport={classReport}
          filterLabel={null !== labelValue ? labelValue as string : null}
          filteredIds={filteredStudentsIds}
          showOthersData={showOthersData}
          metricsSettings={metricsSettings!}
          dateRange={dateRange}
          groupId={groupId}
        />
      )}
    </div>
  );
};

export default ReportBody;
